const languageLabel = locale =>
  ({
    'en-US': 'English',
    'es-ES': 'Español',
    default: 'English',
  }[locale]);

export default languageLabel;
